import axios from 'axios'

const state = {
};

const mutations = {

};

const actions = {
	GET_VERSION () {
		return axios.get('/version' + '?t=' + new Date().getTime())
			.then(response => {
				return response.data.trim();
			})
            .catch(error=>{
                return Promise.reject(error.response);
            })
	},
};

export default {
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/version.js